export default __webpack_public_path__ + "static/media/nodejs.6d4c7d46.png";